export default "__VITE_ASSET__BoZd$yVU__"